import { getDataIdsFromContract } from '../../../../shared/utils/dataId';

export const JOB_MODE_BADGE_DATA_IDS = getDataIdsFromContract({
  base: 'job-mode-badge',
  mode: 'mode',
  modeIcon: 'mode-icon',
  copy: 'copy',
  jobId: 'job-id'
});
